import { render, staticRenderFns } from "./WorkPackageListItem.vue?vue&type=template&id=0658e041&scoped=true"
import script from "./WorkPackageListItem.vue?vue&type=script&lang=js"
export * from "./WorkPackageListItem.vue?vue&type=script&lang=js"
import style0 from "./WorkPackageListItem.vue?vue&type=style&index=0&id=0658e041&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0658e041",
  null
  
)

export default component.exports